// import React, { useRef } from "react";
// import { toPng } from "html-to-image";
// import "./QuoteTamplate.css";

// export default function QuoteCard() {
//   const cardRef = useRef(null);

//   const downloadImage = async () => {
//     if (!cardRef.current) {
//       console.error("Card reference is null");
//       return;
//     }

//     try {
//       const dataUrl = await toPng(cardRef.current, {
//         cacheBust: true,
//         pixelRatio: 2,
//         width: 1080,
//         height: 1350,
//         canvasWidth: 1080,
//         canvasHeight: 1350,
//       });

//       const link = document.createElement("a");
//       link.download = "quote-card.png";
//       link.href = dataUrl;
//       link.click();
//     } catch (error) {
//       console.error("Download Error:", error);
//     }
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <div ref={cardRef} className="quote-card">
//         <div className="quote-container">
//           <p className="quote">
//             The real test of a hydroponic company begins after the installation
//             is completed.
//           </p>
//         </div>
//       </div>

//       <button
//         onClick={downloadImage}
//         style={{
//           marginTop: 20,
//           padding: "12px 24px",
//           fontSize: 18,
//           cursor: "pointer",
//         }}
//       >
//         Download PNG
//       </button>
//     </div>
//   );
// }

import React from "react";
import "./QuoteTamplate.css";

export default function QuoteCard({ quote }) {
  return (
    <div className="quote-card">
      <div className="quote-container">
        <p className="quote">{quote}</p>
      </div>
    </div>
  );
}